export default __webpack_public_path__ + "static/media/eternal_instagram.344d830b.svg";